// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKING!
export const VERSION = {
    "dirty": false,
    "raw": "v1.7.10-0-g10be570b",
    "hash": "g10be570b",
    "distance": 0,
    "tag": "v1.7.10",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.7.10",
        "major": 1,
        "minor": 7,
        "patch": 10,
        "prerelease": [],
        "build": [],
        "version": "1.7.10"
    },
    "suffix": "0-g10be570b",
    "semverString": "1.7.10",
    "version": "1.7.10",
    "versionDateTime": "2026-10-22T10:00:58.477Z"
};
